import data from "../data/data.json";

function sendWaMessage(e) {
  e.preventDefault();
  const phoneNumber = data.socialMedia.whatsApp0 || data.socialMedia.whatsApp0; // Replace with your phone number in international format
  const email = e.target.email.value;
  const message =
    "Hello, my email is " + email + ". I would like to get more information.";
  const url = `${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;
  window.open(url, "_blank");
}
export default sendWaMessage;
